/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.3.1(bac26893f27c9ed9e67951f467120ce782f58226)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/languages/less/common/lessWorker.nls.it", {
	"vs/languages/less/common/services/intelliSense": [
		"stringa codificata nell\'URL",
		"contenuto stringa di escape",
		"sostituzione stringa",
		"rimuove o cambia l\'unità di una dimensione",
		"analizza una stringa in un colore",
		"converte i numeri da un tipo in un altro",
		"incorpora una risorsa e passa a `url()`",
		"restituisce il numero di elementi in un elenco dei valori",
		"restituisce un valore in corrispondenza della posizione specificata nell\'elenco",
		"valore assoluto di un numero",
		"arcocoseno - inverso della funzione coseno",
		"arcoseno - inverso della funzione seno",
		"arrotonda per eccesso a un intero",
		"funzione coseno",
		"arrotonda per difetto a un intero",
		"converte in una percentuale, ad esempio 0,5 > 50%",
		"arrotonda un numero a un numero di cifre",
		"calcola la radice quadrata di un numero",
		"funzione seno",
		"funzione tangente",
		"arcotangente - inverso della funzione tangente",
		"restituisce pi greco",
		"primo argomento elevato alla potenza del secondo argomento",
		"secondo argomento del resto del primo argomento",
		"restituisce il minore di uno o più valori",
		"restituisce il minore di uno o più valori",
		"crea un elemento #AARRGGBB",
		"crea un colore",
		"crea un colore",
		"crea un colore",
		"crea un colore",
		"restituisce il canale `hue` di `@color` nello spazio HSL",
		"restituisce il canale `saturation` di `@color` nello spazio HSL",
		"restituisce il canale `lightness` di `@color` nello spazio HSL",
		"restituisce il canale `hue` di `@color` nello spazio HSV",
		"restituisce il canale `saturation` di `@color` nello spazio HSV",
		"restituisce il canale `value` di `@color` nello spazio HSV",
		"restituisce il canale `red` di `@color`",
		"restituisce il canale `verde` di `@color`",
		"restituisce il canale `blue` di `@color`",
		"restituisce il canale `alpha` di `@color`",
		"restituisce il valore `luma` (luminosità percepita) di `@color`",
		"restituisce `@color` con una saturazione punti aumentata del 10%",
		"restituisce `@color` con una saturazione punti ridotta del 10%",
		"restituisce `@color` con punti più chiari del 10%",
		"restituisce `@color` con punti più scuri del 10%",
		"restituisce `@color` con una trasparenza punti ridotta del 10%",
		"restituisce `@color` con una trasparenza punti aumentata del 10%",
		"restituisce `@color` con una trasparenza pari al 50%",
		"restituisce `@color` con una tonalità aumentata di 10 gradi",
		"restituisce una combinazione di `@color1` e `@color2`",
		"restituisce un colore grigio, desaturato al 100%",
		"restituisce `@darkcolor` se il valore di @color1 supera del 43% quello di luma, altrimenti restituisce `@lightcolor`; vedere le note",
	]
});